import { OrgUnitDto } from "core/types/orgUnit.types";
import queryString from "query-string";

import { AxiosInstance } from "@bps/http-client";

import {
  AppointmentTypeTGArgs,
  AppointmentTypeTGDto,
  TenantProviderDto
} from "./tenant.dtos";
import { ITenantGateway } from "./tenant.gateway.interface";

export class TenantGateway implements ITenantGateway {
  constructor(private api: AxiosInstance) {}
  public getOrgUnits = async (): Promise<OrgUnitDto[]> =>
    (await this.api.get<OrgUnitDto[]>("client/orgUnit")).data;

  public getTenantProviders = async (): Promise<TenantProviderDto[]> =>
    (await this.api.get<TenantProviderDto[]>("client/provider")).data;

  public getAppointmentTypesTG = async (
    args?: AppointmentTypeTGArgs
  ): Promise<AppointmentTypeTGDto[]> => {
    const { stringify } = queryString;
    return (
      await this.api.get<AppointmentTypeTGDto[]>(
        `appointmentTypes?${stringify(args!)}`
      )
    ).data;
  };
}
